import _ from 'underscore';
import ko from 'knockout';
import UrlInput from '@bingads-webui-component-legacy/url-input/view/url-input';
import template from '@bingads-webui-component-legacy/url-input/template/url-input-core.pug';

export default class extends UrlInput {
  initialize({ observable }) {
    const url = _.isArray(observable()) ? _.first(observable()) : observable();

    super.initialize(
      _.chain({
        url,
        maxFullUrlLength: ko.unwrap(observable.maxLength),
        template,
      })
        .pick(Boolean)
        .value()
    );

    this.on(
      'urlChanged',
      (valueFromUrlInput) => {
        // UrlInput uses null as invalid value, here we want it to be empty string
        const val = _.isEmpty(valueFromUrlInput) ? '' : valueFromUrlInput;

        if (_.isArray(observable())) { // if is array set array
          if (_.isEmpty(val)) { // if val is empty, set empty array rather than [""]
            observable([]);
          } else {
            observable([val]);
          }
        } else {
          observable(val);
        }
      }
    );
  }
}
